import React, { useState,useEffect } from 'react';
import {Navbar,Nav,NavDropdown} from 'react-bootstrap'
import logo from "../Assets/images/logo.png"
import { NavLink } from 'react-router-dom';
import Connect from './Modal/ConnectModal';
import { getAccount } from '../Hooks/useAccounts';
import { UseProvider } from '../Hooks/UseWeb3';
import {style,iconTheme,position} from '../Hooks/useToast'
import toast, { Toaster } from 'react-hot-toast';
import { getSettingsData } from '../Hooks/UseBackend';

const Header = () =>{
    const[connect, setConnect] = useState(false)
    const [accountInfo, setAccountInfo] = useState("");
    const [settingdata,setsettingdata] = useState([])

  useEffect(()=>{
    setAccountInfo(getAccount());
    getData()
  },[])


  const logOut = async () => {
    setAccountInfo("");
    localStorage.removeItem("accountInfo")
    if (localStorage.getItem("walletconnect") != null) {
        const provider = await UseProvider();
        await provider.disconnect()
    }

    
    toast.success("Wallet Disconnected successfully", {
      position:position.position,
      style:style,
      iconTheme: iconTheme,
  })
  setTimeout(() => {
      
      window.location.reload()
  }, 1000);
}

   

    const getData =async() =>{
        var settingdata = await getSettingsData();
  setsettingdata(settingdata);
    }
    const [headeractive, setHeaderactive] = useState(false);
    const changeNavbarColor = () =>{
      if(window.scrollY >= 50){
        setHeaderactive(true);
      }
      else{
        setHeaderactive(false);
      }
   };
   window.addEventListener('scroll', changeNavbarColor);
    return(
       <div className={!headeractive ? 'header' :'header fxheader'}>
        {connect && <Connect onDismiss={() => setConnect(false)}/>}
        <Navbar bg="dark" expand="lg" variant="dark">
            <div className='container container-theme'>
                <Navbar.Brand href="/">
                    <img src={logo} className="logo"/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mx-auto">
                    <NavLink className="nav-link" to="/">Home</NavLink>
                    <NavLink className="nav-link" to="/launchpad">Launchpad</NavLink>
                    <NavLink className="nav-link" to="/staking">Locked Staking</NavLink>
                    <NavLink className="nav-link" to="/news">News</NavLink>
                    {/* <a target="blank"className="nav-link" href={settingdata && settingdata[3]?.Description} >News</a> */}
                    {(accountInfo == "" || accountInfo == null)?
                    <button className='btn btn getstarted ms-lg-3' onClick={() => setConnect(true)}>Connect</button> :
                    <button className='btn btn getstarted ms-lg-3' onClick={() => logOut()}>{`${accountInfo.substring(0, 5)}...${accountInfo.substring(38,42)}`}</button>}
                 <NavLink className="nav-link" to="/map">Map</NavLink>
                </Nav>
                <a target='blank'  className='btn-overall' href="/launchpad">  Get Started</a>
                </Navbar.Collapse>
                </div>
        </Navbar>
       </div>
    )
}

export default Header